// Action types for NV06 - Alfakodeoversikt
export const NV06_ALFA_OVERSIKT_GET = 'NV06_ALFA_OVERSIKT_GET';
export const NV06_ALFA_OVERSIKT_SUCCESS = 'NV06_ALFA_OVERSIKT_SUCCESS';
export const NV06_ALFA_OVERSIKT_FAILURE = 'NV06_ALFA_OVERSIKT_FAILURE';

export const NV06_RESET = 'NV06_RESET';
